import React from 'react'
import PropTypes from 'prop-types'

const BOTServicesList = ({ servicesText }) =>
  <div dangerouslySetInnerHTML={{ __html: servicesText }} />

BOTServicesList.propTypes = {
  servicesText: PropTypes.string
}

export default BOTServicesList
